import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API } from '../../api';

@Injectable({
    providedIn: 'root'
})
export class ProductTypeService {
    private url: string = API + '/product-type';

    constructor(private http: HttpClient) { }

    getProductTypes(): Observable<any> {
        return this.http.get(this.url);
    }
}
